/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 39,
  image: "default-changelog-v2.png",
  title: "Platform Improvements & Fixes",
  shortDescription: "We have released a new version of the Spheron platform with a couple of improvements and fixes.",
  description: "We have released a new version of the Spheron platform with a couple of improvements and fixes.",
  date: "July 24th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `

## Platform Improvements & Fixes

- **Selected organization changes when refreshing:** Fixed the issue causing the selected organization to change unexpectedly when refreshing the Compute pages.
- **Enhanced Compute Marketplace Templates:** Added tooltips for a more user-friendly experience when deploying clusters from marketplace templates. These tooltips display the corresponding environment variable names, making it easier to identify the specified values.
- **Error while adding a new network:** Fixed the issue where an error used to pop out while adding a new network.
- **Compute Fixes:**
  - **Addressed input type issues for secret environment variables:** Now, the inputs are correctly configured to handle secret environment variables, ensuring data privacy and security.
  - **Restricted negative values for ports input:** Users can no longer input negative values for ports, preventing potential conflicts and ensuring valid configurations.
  - **Resolved search input loading issue:** The search input no longer triggers unnecessary loading when searching through compute plans, leading to a smoother and more efficient user experience.
  - **Enhanced image details inputs validation:** Improved validation for image details inputs to detect unsaved or outdated information. Users will receive appropriate feedback and guidance to ensure accurate and up-to-date configurations.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
